// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11-dq","left":"styles_left__1s2Tq"};